module.exports = __webpack_public_path__ + "static/media/external.295b4ec9.svg";